<template>
  <main v-if="loadover" class="Index">
    <div v-if="true">
      <div :style="{ 'background-image': `url(${info.article[0].image})` }">
        <p>{{ info.article[0].title }}</p>
        <p>{{ info.article[0].summary }}</p>
        <el-button type="primary" @click="btnClick('Go')">
          了解详情
          <span class="iconfont icon-fanhuizuojiantouxiangzuoshangyibuxianxing"></span>
        </el-button>
      </div>
      <div :style="{ 'background-image': `url(${info.article[1].image})` }">
        <p>{{ info.article[1].title }}</p>
        <p>{{ info.article[1].summary }}</p>
        <el-button type="primary" @click="btnClick('Product')">
          了解详情
          <span class="iconfont icon-fanhuizuojiantouxiangzuoshangyibuxianxing"></span>
        </el-button>
      </div>
      <div :style="{ 'background-image': `url(${info.article[2].image})` }">
        <p>{{ info.article[2].title }}</p>
        <div class="div3">
          <!-- 小轮播 -->
          <el-carousel
            :interval="4000"
            type="card"
            height="16.82vw"
            indicator-position="none"
            class="carousel"
          >
            <el-carousel-item v-for="(imgitem, index) of info.article[2].images" :key="index">
              <el-image
                :src="imgitem.image"
                fit="contain"
                :preview-src-list="
                  info.article[2].images.map((i) => {
                    return i.image;
                  })
                "
              />
            </el-carousel-item>
          </el-carousel>
          <div>
            <p>{{ info.article[2].summary }}</p>
            <el-button type="primary" @click="btnClick('Product', 'technologyP')">
              了解详情
              <span class="iconfont icon-fanhuizuojiantouxiangzuoshangyibuxianxing"></span>
            </el-button>
          </div>
        </div>
      </div>
      <div>
        <div id="moveimg">
          <!-- 六个框框的父元素 -->
          <table align="center">
            <tr>
              <td v-for="(i, n) in info.dynamic.slice(0, 3)" :key="n">
                <p>{{ i.description }}</p>
                <p>{{ i.name }}</p>
              </td>
            </tr>
            <tr>
              <td v-for="(i, n) in info.dynamic.slice(3)" :key="n+3">
                <p>{{ i.description }}</p>
                <p>{{ i.name }}</p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <articel v-else />
  </main>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import rotate3d from "../components/common/rotate3d.vue";
import articel from "../components/common/articel.vue";
export default {
  components: { articel },
  name: "Index",
  data() {
    return {
      x: 0,
      y: 0,
      divbgTimer: null,
      loadover: false,
      info: {},
      Indexbuttom: [
        { number: 200, name: "合作医院", id: 1 },
        { number: 200, name: "合作医院", id: 2 },
        { number: 200, name: "合作医院", id: 3 },
        { number: 200, name: "合作医院", id: 4 },
        { number: 200, name: "合作医院", id: 5 },
        { number: "10000+", name: "合作医院", id: 6 },
      ],
    };
  },
  computed: { ...mapGetters(["meanTree"]) },
  created() {
    this.getCommon().then((common) => {
      this.getCate({ parent: common.menus[0] }).then(() => {
        this.getIndex();
      });
    });
  },
  methods: {
    ...mapActions(["getCommon", "toArticel", "getCate"]),
    getIndex() {
      this.$api.INDEX().then((info) => {
        this.$public_data
          .imageURL(info.article)
          .then((IMG) => {
            Object.assign(this.info, info);
            this.loadover = true;
            setTimeout(() => {
              this.bgMove();
            }, 1000);
          })
          .catch((err) => {
            console.log(err, "indexerr");
          });
      });
    },
    btnClick(pname, cname) {
      new Promise((resolve, reject) => {
        let parent = {};
        let _child = {};
        this.meanTree._child.map((p) => {
          // 前两个
          // if (index == 2) {
          if (p.name == pname) {
            if (!cname) {
              parent = p;
              resolve({ parent: p, _child: {} });
            } else {
              p._child.map((c) => {
                parent = p;
                if (c.name == cname) {
                  _child = c;
                  resolve({ parent: p, _child: c });
                }
              });
            }
          }
        });
      })
        .then((res) => {
          // console.log(res);
          let n = Object.keys(res._child).length > 0 ? true : false;
          this.getCate({ parent: res.parent, _child: n ? res._child : null });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    bgMove() {
      var divbg = document.getElementById("moveimg"); //获取div
      //背景移动函数
      divbg.style.backgroundPositionX = this.x + "px"; //对div对象的背景图片进行移动
      if (this.x + this.y > 1100) {
        this.x = 2;
        this.y = 2;
      } else {
        this.x += 2; //向右移动
        this.y += 2;
      }
      divbg.style.backgroundPositionY = this.y + "px";
      this.divbgTimer = window.requestAnimationFrame(this.bgMove);
      // this.divbgTimer = setInterval(moveBg, 16.7); //设置调用这个方法的定时器，100ms调用一次
      // }
    },
  },
  beforeDestroy() {
    if (this.divbgTimer) {
      cancelAnimationFrame(this.divbgTimer);
      clearInterval(this.divbgTimer);
      this.divbgTimer = null;
    }
    // console.log("beforeDestroy", this.divbgTimer);
  },
};
</script>

<style scoped lang='less'>
@import url("../assets/3d.css");
.el-button {
  min-width: 8.2vw;
  height: 4vw;
  line-height: 1vw;
  background: #1680d9;
  font-size: 1.04vw;
  margin-left: 64vw;
  border: 0.52vw solid #fff;
}
.el-button:hover {
  background: #49a0e7;
  border-color: #49a0e7;
}
@keyframes rotation {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}
#cursorMove {
  width: 100vw !important;
  background-image: url("../assets/image/1.jpg");
}
.Index {
  > div {
    > div {
      overflow: hidden; //margin-top
      height: 42.7vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    > div {
      width: 100vw;
      height: 42.7vw;
      background-image: url("../assets/image/banner@3x.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      > p {
        margin: 4.67vw 0 3.1vw 16vw;
        color: #333;
      }
      > p:first-child {
        font-size: 2.4vw;
        font-weight: bold;
        + p {
          font-size: 1.56vw;
          width: 57.7vw;
          line-height: 2;
        }
      }
      > div {
        position: relative;
        width: 77.7vw;
        margin-left: 16vw;
        font-size: 1.25vw;
        display: flex;
        justify-content: space-between;
        // 小轮播
        .carousel {
          width: 28.6vw;
        }
        > div {
          .el-image {
            width: 23.4vw;
            height: 13vw;
            img {
              width: 100%;
              height: 100%;
            }
          }
          > p {
            line-height: 1.5;
          }
          > .el-button {
            margin-left: 45%;
            margin-top: 1.56vw;
          }
        }
        > div:last-child {
          width: 37.1vw;
        }
      }
    }
    > div:nth-child(2) {
      > p:first-child {
        margin-top: 17.1vw;
        + p {
          margin-top: 3.64vw;
        }
      }
    }
    > div:nth-child(3) {
      > p {
        margin-top: 6.81vw;
        margin-bottom: 4.16vw;
      }
    }
    > div:last-child {
      background: none;
      background-position: center;
      background-size: 67%;
      height: 34.7vw;
      > div {
        margin: 4.16vw auto;
        width: 77.7vw;
        height: 26.4vw;
        background: url("../assets/image/bg004.png");
        // background-size: 77.7vw 26.35vw;
        // 6框框父元素
        > table {
          margin: 5800/1920vw auto;
          text-align: center;
          color: #fff;
          width: 82000/1920vw;
          height: 38600/1920vw;
          > tr {
            > td {
              width: 27300/1920vw;
              height: 19800/1920vw;
              border: 1px solid #9ee6ff;
              border-top: none;
              border-left: none;
              > p:first-child {
                font-size: 6000/1920vw;
                + p {
                  font-size: 2400/1920vw;
                }
              }
            }
            > td:last-child {
              border-right: none;
            }
          }
          > tr:last-child {
            > td {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}
.box {
  display: flex;
  flex-flow: row nowrap;
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue